import { render, staticRenderFns } from "./NewChatAttachmentViewer.vue?vue&type=template&id=0ad60b0c"
import script from "./NewChatAttachmentViewer.vue?vue&type=script&lang=js"
export * from "./NewChatAttachmentViewer.vue?vue&type=script&lang=js"
import style0 from "./NewChatAttachmentViewer.vue?vue&type=style&index=0&id=0ad60b0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports